export const setStreamsType = (elements: any, streams: any, diagramData: any) => 
{
  // console.log('diagramData',diagramData);
  // console.log('elements',elements);
  // console.log('streams',streams);
  const { linkDataArray, nodeDataArray } = diagramData;

  let newStreams = [...streams];

  const elementMap: any = [];
  elements.forEach((element: any) => {
    const node = nodeDataArray.find((e: any) => e.nodeName === element.name);
    elementMap.push(node.key);
  });

  newStreams.forEach((stream: any) => {
    const link = linkDataArray.find((e: any) => e.linkName === stream.name);
    const { from, to } = link;
    if (elementMap.includes(from) && elementMap.includes(to)) {
      stream.type = "内部";
    } else if (elementMap.includes(from) && !elementMap.includes(to)) {
      stream.type = "出料";
    } else if (!elementMap.includes(from) && elementMap.includes(to)) {
      stream.type = "进料";
    }
  });
  return newStreams;
};